import { Link, useNavigate } from 'react-router-dom'
import { Plus, Building2, ChevronRight, Briefcase } from 'lucide-react'
import { Button } from '@/components/ui'
import { useBusinesses } from '@/hooks/useBusinesses'

export function BusinessListPage() {
  const { businesses, isLoading, error } = useBusinesses()
  const navigate = useNavigate()

  if (isLoading) {
    return (
      <div className="flex flex-col items-center justify-center py-20 text-slate-500">
        <div className="w-8 h-8 border-4 border-brand-500 border-t-transparent rounded-full animate-spin mb-4" />
        <p>Memuat daftar bisnis...</p>
      </div>
    )
  }

  if (error) {
    return (
      <div className="p-4 bg-red-500/10 border border-red-500/20 rounded-lg text-red-400">
        <p>Gagal memuat bisnis: {error}</p>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-slate-100">Bisnis Saya</h1>
          <p className="text-sm text-slate-400 mt-1">Kelola dan pantau semua unit bisnis Anda</p>
        </div>
        <Button onClick={() => navigate('/businesses/new')} className="shrink-0 gap-2">
          <Plus size={16} />
          Buat Bisnis Baru
        </Button>
      </div>

      {businesses.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-24 px-4 text-center border border-dashed border-slate-700 rounded-xl bg-slate-800/20">
          <div className="w-16 h-16 bg-slate-800 rounded-2xl flex items-center justify-center mb-4 text-slate-500">
            <Building2 size={32} />
          </div>
          <h3 className="text-lg font-semibold text-slate-200">Belum ada bisnis</h3>
          <p className="text-sm text-slate-400 mt-2 max-w-sm mb-6">
            Mulai kelola kas, produk, dan buat simulasi keuangan dengan menambahkan bisnis pertama Anda.
          </p>
          <Button onClick={() => navigate('/businesses/new')} variant="outline" className="gap-2">
            <Plus size={16} />
            Buat Bisnis Pertama
          </Button>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
          {businesses.map(b => (
            <Link
              key={b.id}
              to={`/businesses/${b.id}`}
              className="group block p-5 rounded-xl border border-slate-800 bg-slate-900 hover:border-brand-500/50 hover:bg-slate-800/50 transition-all shadow-sm hover:shadow-brand-900/10"
            >
              <div className="flex justify-between items-start mb-4">
                <div className="p-2.5 bg-slate-800 rounded-lg text-brand-400 group-hover:bg-brand-500/10 group-hover:text-brand-300 transition-colors">
                  <Briefcase size={20} />
                </div>
                <span className={`text-[10px] font-medium px-2 py-1 rounded-full uppercase tracking-wider
                  ${b.stage === 'running' ? 'bg-emerald-500/10 text-emerald-400 border border-emerald-500/20' : 
                    b.stage === 'planning' ? 'bg-blue-500/10 text-blue-400 border border-blue-500/20' : 
                    b.stage === 'closed' ? 'bg-slate-500/10 text-slate-400 border border-slate-500/20' :
                    'bg-amber-500/10 text-amber-400 border border-amber-500/20'
                  }
                `}>
                  {b.stage}
                </span>
              </div>
              <h3 className="text-lg font-bold text-slate-100 mb-1 group-hover:text-brand-300 transition-colors">{b.name}</h3>
              <p className="text-xs text-slate-500 mb-6">{b.businessType || 'Belum ada kategori'}</p>
              
              <div className="flex items-center justify-between text-xs font-medium text-slate-400 group-hover:text-brand-400 transition-colors pt-4 border-t border-slate-800/50">
                <span>Buka Dashboard</span>
                <ChevronRight size={14} className="group-hover:translate-x-1 transition-transform" />
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  )
}
